/**
 * Application entry point
 * Initializes React and i18n
 * 
 * NOTE: Authentication has been completely removed
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './core/i18n/i18n.config';
import './styles/variables.css';
import './styles/global.css';
import { initializeInterceptors } from '@services/api/interceptors';
import { initializeRetryInterceptor } from '@services/api/retry-interceptor';

// Register axios interceptors before any React effect can fire API calls
// (provider effects run before App's useEffect, so late init caused unauthenticated requests).
initializeInterceptors();
if (typeof window !== 'undefined' && window._env_?.AIPORTAL_ENABLE_RETRY !== 'false') {
  initializeRetryInterceptor();
}

// Load proxy test utilities in development (available in browser console)
if (import.meta.env.DEV) {
  import('./services/proxy.test');
}

// Initialize React app - no auth initialization
const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);